// „Salon fondator" seal — a Meta/Instagram-style verified badge: scalloped
// circle + check, drawn as our own SVG (an 8-scallop rosette; not a copy of
// any platform's asset) in brand primary-500. Sits INLINE next to the salon
// name wherever it appears, replacing the earlier text pill at the owner's
// request — the seal-next-to-name pattern is universally read as "verified/
// special", and the accessible title still spells out what it means.
//
// The scallops come from a 16-vertex polygon alternating radius 10 / 8.3
// around (12,12); the thick round-joined stroke is what melts the polygon
// into smooth scallops at small sizes.
export default function FounderBadge({ className = 'h-4 w-4' }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={`${className} shrink-0 text-primary-500`}
      role="img"
      aria-label="Salon fondator"
    >
      <title>Salon fondator</title>
      <polygon
        points="22,12 19.67,15.18 19.07,19.07 15.18,19.67 12,22 8.82,19.67 4.93,19.07 4.33,15.18 2,12 4.33,8.82 4.93,4.93 8.82,4.33 12,2 15.18,4.33 19.07,4.93 19.67,8.82"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path
        d="M7.8 12.3l2.8 2.8 5.6-6"
        fill="none"
        stroke="#FFFDF8"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
